import type { DriftCollection } from '../api'
import { msg, type Msg } from '../i18n'

// Тон подсказки в контролах сноса: нейтральная инфо / предупреждение / пусто.
export type DriftStatusTone = 'muted' | 'warn' | 'empty'

export interface DriftStatus {
  tone: DriftStatusTone
  /** Части сводки: компонент склеивает их через « · ». Не одна готовая фраза —
   *  порядок и связки в английском другие, а логика про язык знать не должна. */
  parts: Msg[]
}

// Чистая логика подсказки под контролами сноса — без React, легко тестируется.
// Накопительная модель: окно — только фильтр отображения, треки готовы в БД.
// Порядок: выключено → нет вида → загрузка → нет ответа → сводка.
// Сводка: «{shown} точек · течения по {currents_through}» + мягкие пометки
// «· {gap} ждут свежих течений» (дозаполнится, не ошибка) и «· {beached} у берега».
export function driftStatus(args: {
  enabled: boolean
  speciesSelected: boolean
  loading: boolean
  data: DriftCollection | undefined
}): DriftStatus | null {
  const { enabled, speciesSelected, loading, data } = args
  if (!enabled) return null
  if (!speciesSelected) return { tone: 'muted', parts: [msg('models.drift.status.pickSpecies')] }
  if (loading) return { tone: 'muted', parts: [msg('models.drift.status.loading')] }
  if (!data) return null

  const meta = data.meta

  // Пусто в окне — либо течений ещё нет, либо наблюдений в окне нет.
  if (meta.shown === 0) {
    if (!meta.currents_through) {
      return { tone: 'empty', parts: [msg('models.drift.status.noCurrents')] }
    }
    return { tone: 'empty', parts: [msg('models.drift.status.noObservations')] }
  }

  const parts: Msg[] = [
    msg('models.drift.status.points', { count: meta.shown }),
    msg('models.drift.status.currentsThrough', { date: meta.currents_through ?? '—' }),
  ]
  // gap — трек ждёт свежих течений и дозаполнится (физика, не ошибка).
  if (meta.gap > 0) parts.push(msg('models.drift.status.gap', { count: meta.gap }))
  // beached — трек уткнулся в берег.
  if (meta.beached > 0) parts.push(msg('models.drift.status.beached', { count: meta.beached }))

  // gap/beached — не ошибка, но подсвечиваем мягким тоном, чтобы обратить внимание.
  const tone: DriftStatusTone = meta.gap > 0 || meta.beached > 0 ? 'warn' : 'muted'
  return { tone, parts }
}
